<div class="dialog">
  <button class="close-dialog-btn" aria-label="Close dialog button" (click)="closeEvent.emit($event)">
    <mat-icon class="close-icon" aria-label="close dialog button" aria-hidden="false" svgIcon="cross_fill"></mat-icon>
  </button>
  <div class="dialog-content">
    <ng-content></ng-content>
  </div>
</div>
